<div class="main-input-form">
    <form #myForm="ngForm" (ngSubmit)="save()">
      <div class="input-wrapper">
          <div class="side-wrapper edit-form-title-wrapper">
              <div class="user-icon"></div>
              <p class="input-form-title">{{'NAVIGATION_NODE_RULE.FORM_TITLE' | translate}}</p>
          </div>
  
          <div class="menu-input-wrapper">
              <div class="tab-menu">
                  <div class="tab basic-info" (click)="setActiveTab('basic-info')" [ngClass]="{'active': activetab=='basic-info'}">
                      <p>{{'HOME.ROLES_BASICINFO_TABTITLE' | translate}}</p>
                  </div>
              </div>
              <!--
              -->
              <div class="input-content">
                  <div class="basic-info" *ngIf="activetab == 'basic-info'">
  
                      <div class="section-wrapper">
                          <p class="section-title">{{'HOME.USERS_BASICINFO_GENERAL' | translate}}</p>
                      </div>
  
                      <div class="side-combiner">
                          <div class="side-input-container">
                            <div class="input-control">
                                <div class="title"><label for="RuleType">{{'NAVIGATION_NODE_RULE.TYPE' | translate}}</label></div>
                                <input class="form-control" type="text" name="RuleType" [(ngModel)]="model.RuleType" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="Condition">{{'NAVIGATION_NODE_RULE.CONDITION' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="Condition" [(ngModel)]="model.Condition" ></textarea>
                            </div>                            
                            <div class="input-control">
                                <div class="title"><label for="ActionBody">{{'NAVIGATION_NODE_RULE.ACTIONBODY' | translate}}</label></div>
                                <textarea rows="10" class="form-control" type="text" name="ActionBody" [(ngModel)]="model.ActionBody"></textarea>
                            </div>                            
                            <div class="input-control">
                                <div class="title"><label for="UserId">{{'NAVIGATION_NODE_RULE.USER' | translate}}</label></div>
                                <input class="form-control" type="number" name="UserId" [(ngModel)]="model.UserId" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="UserGroupId">{{'NAVIGATION_NODE_RULE.USERGROUP' | translate}}</label></div>
                                <input class="form-control" type="number" name="UserGroupId" [(ngModel)]="model.UserGroupId" />
                            </div>
                            <div class="input-control">
                                <div class="title"><label for="FormActionId">{{'NAVIGATION_NODE_RULE.FORMACTION' | translate}}</label></div>
                                <input class="form-control" type="number" name="FormActionId" [(ngModel)]="model.FormActionId" />
                            </div>                            
                          </div>
                          <!--
                          -->
                          <div class="side-input-container">
                              <div class="input-control">
                              </div>
                          </div>
                      </div>
                  </div> 
              </div>
          </div>
  
      </div>
  </form>
  </div>